/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DeletedItem } from '../../models/deleted-item';

export interface MediaControllerDeleteFile$Params {
  prefix: string;
  name: string;
  folder: boolean;
}

export function mediaControllerDeleteFile(http: HttpClient, rootUrl: string, params: MediaControllerDeleteFile$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DeletedItem;
}>> {
  const rb = new RequestBuilder(rootUrl, mediaControllerDeleteFile.PATH, 'delete');
  if (params) {
    rb.query('prefix', params.prefix, {});
    rb.query('name', params.name, {});
    rb.query('folder', params.folder, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: DeletedItem;
      }>;
    })
  );
}

mediaControllerDeleteFile.PATH = '/file-manager/delete';
